<template>
<div class="projectcellconfig">
  <el-card shadow="never">{{ projectName }}</el-card>
  <el-card shadow="never">
    <el-row :gutter="20">
      <el-col :span="4">
        <el-card shadow="never" style="height: 40%;">
          <div slot="header" class="clearfix"><span>EMS列表</span></div>
          <ul class="ems-list">
            <li v-for="(item, index) in emsData" :key="index" :class="{ actived: currentSn == item.sn }">
              <div @click="clickEms(item)">{{ item.sn }}</div>
            </li>
          </ul>
        </el-card>
      </el-col>
      <el-col :span="20" v-show="currentSn">
        <el-row>
          <el-col :span="24" style="text-align: center;">
            <span style="font-size: 18px;">EMS列表</span>
          </el-col>
        </el-row>
        <el-card shadow="never" style="height: 56vh;margin-top: 20px;overflow-y: auto;">
          <div class="batteryClusterTemplate">
            <div class="configBtn">
              <el-input-number v-model="templateNum" @change="templateHandleChange" :min="0" label="描述文字" style="width: 150px;top: 15px;right: 25px;"></el-input-number>
            </div>
            <el-form ref="templateFormRef" label-width="120px" label-position="left" style="border: 2px solid #ebeef5;border-radius: 6px;min-height: 10vh;margin-bottom: 40px;padding: 15px;">
              <div v-for="(item, index) in fieldRuleConfig" :key="index">
                <el-form-item class="configTitle" :label="'电池簇模板'+(index+1)"></el-form-item>
                <div class="configArea">
                  <template>
                    <el-form label-width="120px" label-position="right">
                      <el-form-item class="configTitle" label="电池簇配置">
                        <div style="float: right;">
                          <el-button :type="item.cellClustersCodeIsContinue?'primary':''" @click="cellClustersCodeIsContinueClick(index)">电池簇编号是否连续</el-button>
                          <el-button :type="item.cellClustersIsFixZero?'primary':''" @click="cellClustersIsFixZeroClick(index)">电池簇编号是否补0</el-button>
                        </div>
                      </el-form-item>
                      <div class="configArea">
                        <el-row>
                          <el-col :span="12">
                            <el-form-item label="串:">
                              <el-input v-model="item.cellClustersRules.moduleBunch" style="width: 85%;"></el-input>
                            </el-form-item>
                          </el-col>
                          <el-col :span="12">
                            <el-button :type="item.cellClustersRules.cellClustersIsChar?'primary':''" @click="cellClustersIsCharClick(index)">是否纯字符</el-button>
                          </el-col>
                        </el-row>
                        <el-row>
                          <el-col :span="12">
                            <el-form-item label="电池簇前缀:">
                              <el-input v-model="item.cellClustersRules.cellClustersCodePrefix" style="width: 85%;"></el-input>
                            </el-form-item>
                          </el-col>
                          <el-col :span="12">
                            <el-form-item label="相同前缀电池簇个数:">
                              <el-input v-model="item.cellClustersRules.cellClustersCount" readonly style="width: 85%;"></el-input>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <el-row>
                          <el-col :span="12">
                            <el-form-item label="插箱个数:">
                              <el-input v-model="item.cellClustersRules.plugBoxNumber" style="width: 85%;"></el-input>
                            </el-form-item>
                          </el-col>
                          <el-col :span="12">
                            <el-form-item label="模组个数:">
                              <el-input v-model="item.cellClustersRules.moduleNumber" style="width: 85%;"></el-input>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <el-row>
                          <el-col :span="12">
                            <el-form-item label="电压编号:">
                              <el-input v-model="item.cellClustersRules.voltage" readonly @click.native="openDialog(index, 'voltage')" style="width: 85%;"></el-input>
                              <!-- <el-select v-model="item.cellClustersRules.voltage" clearable filterable remote reserve-keyword placeholder="搜索测点" :remote-method="remoteMethod" style="width: 85%;">
                                <el-option v-html="item0.label" v-for="item0 in options" :key="item0.id" :label="item0.value" :value="item0.value"></el-option>
                                <el-button :disabled="options.length == pageTotal" class="moreBtn" type="text" size="small" @click="searchMore()">更多......</el-button>
                              </el-select> -->
                            </el-form-item>
                          </el-col>
                          <el-col :span="12">
                            <el-form-item label="电流编号:">
                              <el-input v-model="item.cellClustersRules.electricity" readonly @click.native="openDialog(index, 'electricity')" style="width: 85%;"></el-input>
                              <!-- <el-select v-model="item.cellClustersRules.electricity" clearable filterable remote reserve-keyword placeholder="搜索测点" :remote-method="remoteMethod" style="width: 85%;">
                                <el-option v-html="item0.label" v-for="item0 in options" :key="item0.id" :label="item0.value" :value="item0.value"></el-option>
                                <el-button :disabled="options.length == pageTotal" class="moreBtn" type="text" size="small" @click="searchMore()">更多......</el-button>
                              </el-select> -->
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <el-row>
                          <el-col :span="12">
                            <el-form-item label="主正极编号:">
                              <el-input v-model="item.cellClustersRules.majorPositive" readonly @click.native="openDialog(index, 'majorPositive')" style="width: 85%;"></el-input>
                              <!-- <el-select v-model="item.cellClustersRules.majorPositive" clearable filterable remote reserve-keyword placeholder="搜索测点" :remote-method="remoteMethod" style="width: 85%;">
                                <el-option v-html="item0.label" v-for="item0 in options" :key="item0.id" :label="item0.value" :value="item0.value"></el-option>
                                <el-button :disabled="options.length == pageTotal" class="moreBtn" type="text" size="small" @click="searchMore()">更多......</el-button>
                              </el-select> -->
                            </el-form-item>
                          </el-col>
                          <el-col :span="12">
                            <el-form-item label="主负极编号:">
                              <el-input v-model="item.cellClustersRules.majorNegative" readonly @click.native="openDialog(index, 'majorNegative')" style="width: 85%;"></el-input>
                              <!-- <el-select v-model="item.cellClustersRules.majorNegative" clearable filterable remote reserve-keyword placeholder="搜索测点" :remote-method="remoteMethod" style="width: 85%;">
                                <el-option v-html="item0.label" v-for="item0 in options" :key="item0.id" :label="item0.value" :value="item0.value"></el-option>
                                <el-button :disabled="options.length == pageTotal" class="moreBtn" type="text" size="small" @click="searchMore()">更多......</el-button>
                              </el-select> -->
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <el-row>
                          <el-col :span="12">
                            <el-form-item label="正极电阻编号:">
                              <el-input v-model="item.cellClustersRules.positiveResistance" readonly @click.native="openDialog(index, 'positiveResistance')" style="width: 85%;"></el-input>
                              <!-- <el-select v-model="item.cellClustersRules.positiveResistance" clearable filterable remote reserve-keyword placeholder="搜索测点" :remote-method="remoteMethod" style="width: 85%;">
                                <el-option v-html="item0.label" v-for="item0 in options" :key="item0.id" :label="item0.value" :value="item0.value"></el-option>
                                <el-button :disabled="options.length == pageTotal" class="moreBtn" type="text" size="small" @click="searchMore()">更多......</el-button>
                              </el-select> -->
                            </el-form-item>
                          </el-col>
                          <el-col :span="12">
                            <el-form-item label="主负极电阻编号:">
                              <el-input v-model="item.cellClustersRules.negativeResistance" readonly @click.native="openDialog(index, 'negativeResistance')" style="width: 85%;"></el-input>
                              <!-- <el-select v-model="item.cellClustersRules.negativeResistance" clearable filterable remote reserve-keyword placeholder="搜索测点" :remote-method="remoteMethod" style="width: 85%;">
                                <el-option v-html="item0.label" v-for="item0 in options" :key="item0.id" :label="item0.value" :value="item0.value"></el-option>
                                <el-button :disabled="options.length == pageTotal" class="moreBtn" type="text" size="small" @click="searchMore()">更多......</el-button>
                              </el-select> -->
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <!-- <el-row>
                          <el-col :span="12">
                            <el-form-item label="隶属电池堆:">
                              <el-input v-model="item.cellClustersRules.batteryStack" style="width: 85%;"></el-input>
                            </el-form-item>
                          </el-col>
                        </el-row> -->
                        <el-row>
                          <el-col :span="12">
                            <el-form-item label="总充电量:">
                              <el-input v-model="item.cellClustersRules.totalCharge" readonly @click.native="openDialog(index, 'totalCharge')" style="width: 85%;"></el-input>
                            </el-form-item>
                          </el-col>
                          <el-col :span="12">
                            <el-form-item label="总放电量:">
                              <el-input v-model="item.cellClustersRules.totalDischarge" readonly @click.native="openDialog(index, 'totalDischarge')" style="width: 85%;"></el-input>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <el-row>
                          <el-col :span="12">
                            <el-form-item label="当日充电量:">
                              <el-input v-model="item.cellClustersRules.todayCharge" readonly @click.native="openDialog(index, 'todayCharge')" style="width: 85%;"></el-input>
                            </el-form-item>
                          </el-col>
                          <el-col :span="12">
                            <el-form-item label="当日放电量:">
                              <el-input v-model="item.cellClustersRules.todayDischarge" readonly @click.native="openDialog(index, 'todayDischarge')" style="width: 85%;"></el-input>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <el-row>
                          <el-col :span="12">
                            <el-form-item label="组端电压:">
                              <el-input v-model="item.cellClustersRules.groupTerminalVoltage" readonly @click.native="openDialog(index, 'groupTerminalVoltage')" style="width: 85%;"></el-input>
                            </el-form-item>
                          </el-col>
                          <el-col :span="12">
                            <el-form-item label="组端电流:">
                              <el-input v-model="item.cellClustersRules.groupCurrent" readonly @click.native="openDialog(index, 'groupCurrent')" style="width: 85%;"></el-input>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <el-row>
                          <el-col :span="12">
                            <el-form-item label="电压平均值:">
                              <el-input v-model="item.cellClustersRules.voltageAvg" readonly @click.native="openDialog(index, 'voltageAvg')" style="width: 85%;"></el-input>
                            </el-form-item>
                          </el-col>
                          <el-col :span="12">
                            <el-form-item label="电压极差值:">
                              <el-input v-model="item.cellClustersRules.voltageRange" readonly @click.native="openDialog(index, 'voltageRange')" style="width: 85%;"></el-input>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <el-row>
                          <el-col :span="12">
                            <el-form-item label="电压最大值:">
                              <el-input v-model="item.cellClustersRules.voltageFirstMaxValue" readonly @click.native="openDialog(index, 'voltageFirstMaxValue')" style="width: 85%;"></el-input>
                            </el-form-item>
                          </el-col>
                          <el-col :span="12">
                            <el-form-item label="电压最大值编号:">
                              <el-input v-model="item.cellClustersRules.voltageMaxCode" readonly @click.native="openDialog(index, 'voltageMaxCode')" style="width: 85%;"></el-input>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <el-row>
                          <el-col :span="12">
                            <el-form-item label="电压第二大值:">
                              <el-input v-model="item.cellClustersRules.voltageSecondMaxValue" readonly @click.native="openDialog(index, 'voltageSecondMaxValue')" style="width: 85%;"></el-input>
                            </el-form-item>
                          </el-col>
                          <el-col :span="12">
                            <el-form-item label="电压第三大值:">
                              <el-input v-model="item.cellClustersRules.voltageThirdMaxValue" readonly @click.native="openDialog(index, 'voltageThirdMaxValue')" style="width: 85%;"></el-input>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <el-row>
                          <el-col :span="12">
                            <el-form-item label="电压最小值:">
                              <el-input v-model="item.cellClustersRules.voltageFirstMinValue" readonly @click.native="openDialog(index, 'voltageFirstMinValue')" style="width: 85%;"></el-input>
                            </el-form-item>
                          </el-col>
                          <el-col :span="12">
                            <el-form-item label="电压最小值编号:">
                              <el-input v-model="item.cellClustersRules.voltageMinCode" readonly @click.native="openDialog(index, 'voltageMinCode')" style="width: 85%;"></el-input>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <el-row>
                          <el-col :span="12">
                            <el-form-item label="电压最二小值:">
                              <el-input v-model="item.cellClustersRules.voltageSecondMinValue" readonly @click.native="openDialog(index, 'voltageSecondMinValue')" style="width: 85%;"></el-input>
                            </el-form-item>
                          </el-col>
                          <el-col :span="12">
                            <el-form-item label="电压最三小值:">
                              <el-input v-model="item.cellClustersRules.voltageThirdMinValue" readonly @click.native="openDialog(index, 'voltageThirdMinValue')" style="width: 85%;"></el-input>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <el-row>
                          <el-col :span="12">
                            <el-form-item label="温度平均值:">
                              <el-input v-model="item.cellClustersRules.temperatureAvg" readonly @click.native="openDialog(index, 'temperatureAvg')" style="width: 85%;"></el-input>
                            </el-form-item>
                          </el-col>
                          <el-col :span="12">
                            <el-form-item label="温度极差值:">
                              <el-input v-model="item.cellClustersRules.temperatureRange" readonly @click.native="openDialog(index, 'temperatureRange')" style="width: 85%;"></el-input>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <el-row>
                          <el-col :span="12">
                            <el-form-item label="温度最大值:">
                              <el-input v-model="item.cellClustersRules.temperatureFirstMaxValue" readonly @click.native="openDialog(index, 'temperatureFirstMaxValue')" style="width: 85%;"></el-input>
                            </el-form-item>
                          </el-col>
                          <el-col :span="12">
                            <el-form-item label="温度最大值编号:">
                              <el-input v-model="item.cellClustersRules.temperatureMaxCode" readonly @click.native="openDialog(index, 'temperatureMaxCode')" style="width: 85%;"></el-input>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <el-row>
                          <el-col :span="12">
                            <el-form-item label="温度第二大值:">
                              <el-input v-model="item.cellClustersRules.temperatureSecondMaxValue" readonly @click.native="openDialog(index, 'temperatureSecondMaxValue')" style="width: 85%;"></el-input>
                            </el-form-item>
                          </el-col>
                          <el-col :span="12">
                            <el-form-item label="温度第三大值:">
                              <el-input v-model="item.cellClustersRules.temperatureThirdMaxValue" readonly @click.native="openDialog(index, 'temperatureThirdMaxValue')" style="width: 85%;"></el-input>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <el-row>
                          <el-col :span="12">
                            <el-form-item label="温度最小值:">
                              <el-input v-model="item.cellClustersRules.temperatureFirstMinValue" readonly @click.native="openDialog(index, 'temperatureFirstMinValue')" style="width: 85%;"></el-input>
                            </el-form-item>
                          </el-col>
                          <el-col :span="12">
                            <el-form-item label="温度最小值编号:">
                              <el-input v-model="item.cellClustersRules.temperatureMinCode" readonly @click.native="openDialog(index, 'temperatureMinCode')" style="width: 85%;"></el-input>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <el-row>
                          <el-col :span="12">
                            <el-form-item label="温度第二小值:">
                              <el-input v-model="item.cellClustersRules.temperatureSecondMinValue" readonly @click.native="openDialog(index, 'temperatureSecondMinValue')" style="width: 85%;"></el-input>
                            </el-form-item>
                          </el-col>
                          <el-col :span="12">
                            <el-form-item label="温度第三小值:">
                              <el-input v-model="item.cellClustersRules.temperatureThirdMinValue" readonly @click.native="openDialog(index, 'temperatureThirdMinValue')" style="width: 85%;"></el-input>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <el-row>
                          <el-col :span="12">
                            <el-form-item label="SOC平均值:">
                              <el-input v-model="item.cellClustersRules.socAvg" readonly @click.native="openDialog(index, 'socAvg')" style="width: 85%;"></el-input>
                            </el-form-item>
                          </el-col>
                          <el-col :span="12">
                            <el-form-item label="SOC极差值:">
                              <el-input v-model="item.cellClustersRules.socRange" readonly @click.native="openDialog(index, 'socRange')" style="width: 85%;"></el-input>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <el-row>
                          <el-col :span="12">
                            <el-form-item label="SOC最大值:">
                              <el-input v-model="item.cellClustersRules.socFirstMaxValue" readonly @click.native="openDialog(index, 'socFirstMaxValue')" style="width: 85%;"></el-input>
                            </el-form-item>
                          </el-col>
                          <el-col :span="12">
                            <el-form-item label="SOC最大值编号:">
                              <el-input v-model="item.cellClustersRules.socMaxCode" readonly @click.native="openDialog(index, 'socMaxCode')" style="width: 85%;"></el-input>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <el-row>
                          <el-col :span="12">
                            <el-form-item label="SOC第二大值:">
                              <el-input v-model="item.cellClustersRules.socSecondMaxValue" readonly @click.native="openDialog(index, 'socSecondMaxValue')" style="width: 85%;"></el-input>
                            </el-form-item>
                          </el-col>
                          <el-col :span="12">
                            <el-form-item label="SOC第三大值:">
                              <el-input v-model="item.cellClustersRules.socThirdMaxValue" readonly @click.native="openDialog(index, 'socThirdMaxValue')" style="width: 85%;"></el-input>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <el-row>
                          <el-col :span="12">
                            <el-form-item label="SOC最小值:">
                              <el-input v-model="item.cellClustersRules.socFirstMinValue" readonly @click.native="openDialog(index, 'socFirstMinValue')" style="width: 85%;"></el-input>
                            </el-form-item>
                          </el-col>
                          <el-col :span="12">
                            <el-form-item label="SOC最小值编号:">
                              <el-input v-model="item.cellClustersRules.socMinCode" readonly @click.native="openDialog(index, 'socMinCode')" style="width: 85%;"></el-input>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <el-row>
                          <el-col :span="12">
                            <el-form-item label="SOC第二小值:">
                              <el-input v-model="item.cellClustersRules.socSecondMinValue" readonly @click.native="openDialog(index, 'socSecondMinValue')" style="width: 85%;"></el-input>
                            </el-form-item>
                          </el-col>
                          <el-col :span="12">
                            <el-form-item label="SOC第三小值:">
                              <el-input v-model="item.cellClustersRules.socThirdMinValue" readonly @click.native="openDialog(index, 'socThirdMinValue')" style="width: 85%;"></el-input>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <el-row>
                          <el-col :span="12">
                            <el-form-item label="SOH平均值:">
                              <el-input v-model="item.cellClustersRules.sohAvg" readonly @click.native="openDialog(index, 'sohAvg')" style="width: 85%;"></el-input>
                            </el-form-item>
                          </el-col>
                          <el-col :span="12">
                            <el-form-item label="SOH极差值:">
                              <el-input v-model="item.cellClustersRules.sohRange" readonly @click.native="openDialog(index, 'sohRange')" style="width: 85%;"></el-input>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <el-row>
                          <el-col :span="12">
                            <el-form-item label="SOH最大值:">
                              <el-input v-model="item.cellClustersRules.sohFirstMaxValue" readonly @click.native="openDialog(index, 'sohFirstMaxValue')" style="width: 85%;"></el-input>
                            </el-form-item>
                          </el-col>
                          <el-col :span="12">
                            <el-form-item label="SOH最大值编号:">
                              <el-input v-model="item.cellClustersRules.sohMaxCode" readonly @click.native="openDialog(index, 'sohMaxCode')" style="width: 85%;"></el-input>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <el-row>
                          <el-col :span="12">
                            <el-form-item label="SOH第二大值:">
                              <el-input v-model="item.cellClustersRules.sohSecondMaxValue" readonly @click.native="openDialog(index, 'sohSecondMaxValue')" style="width: 85%;"></el-input>
                            </el-form-item>
                          </el-col>
                          <el-col :span="12">
                            <el-form-item label="SOH第三大值:">
                              <el-input v-model="item.cellClustersRules.sohThirdMaxValue" readonly @click.native="openDialog(index, 'sohThirdMaxValue')" style="width: 85%;"></el-input>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <el-row>
                          <el-col :span="12">
                            <el-form-item label="SOH最小值:">
                              <el-input v-model="item.cellClustersRules.sohFirstMinValue" readonly @click.native="openDialog(index, 'sohFirstMinValue')" style="width: 85%;"></el-input>
                            </el-form-item>
                          </el-col>
                          <el-col :span="12">
                            <el-form-item label="SOH最小值编号:">
                              <el-input v-model="item.cellClustersRules.sohMinCode" readonly @click.native="openDialog(index, 'sohMinCode')" style="width: 85%;"></el-input>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <el-row>
                          <el-col :span="12">
                            <el-form-item label="SOH第二小值:">
                              <el-input v-model="item.cellClustersRules.sohSecondMinValue" readonly @click.native="openDialog(index, 'sohSecondMinValue')" style="width: 85%;"></el-input>
                            </el-form-item>
                          </el-col>
                          <el-col :span="12">
                            <el-form-item label="SOH第三小值:">
                              <el-input v-model="item.cellClustersRules.sohThirdMinValue" readonly @click.native="openDialog(index, 'sohThirdMinValue')" style="width: 85%;"></el-input>
                            </el-form-item>
                          </el-col>
                        </el-row>
                      </div>
                    </el-form>
                  </template>
                  <div class="batteryClusterConfig">
                    <template>
                      <el-form label-width="120px" label-position="left">
                        <el-form-item class="configTitle" label="电压配置">
                          <div class="configBtn">
                            <el-input-number v-model="batteryCellNum[index]" @change="(oldval, newval) => batteryCellHandleChange(oldval, newval, index)" :min="0" label="描述文字" style="width: 150px;"></el-input-number>
                            <el-button :type="item.batteryCellIsFixZero?'primary':''" @click="batteryCellIsFixZeroClick(index)">电压编号是否补0</el-button>
                          </div>
                        </el-form-item>
                      </el-form>
                    </template>
                    <template>
                      <el-form class="configArea" label-width="120px" label-position="right">
                        <div v-for="(item1, index1) in item.batteryCellRules" :key="index1">
                          <el-row>
                            <el-col :span="12">
                              <el-form-item label="电压前缀:">
                                <el-input v-model="item1.batteryCellCodePrefix" style="width: 85%;"></el-input>
                              </el-form-item>
                            </el-col>
                            <el-col :span="12">
                              <el-form-item label="电压个数:">
                                <el-input v-model="item1.batteryCellCount" style="width: 85%;"></el-input>
                              </el-form-item>
                            </el-col>
                          </el-row>
                          <el-row>
                            <el-col :span="12">
                              <el-form-item>
                                <el-button :type="item1.batteryCellIsChar?'primary':''" @click="batteryCellIsCharClick(index, index1)">是否纯字符</el-button>
                              </el-form-item>
                            </el-col>
                            <el-col :span="12">
                              <el-form-item label="起始数:">
                                <el-input v-model="item1.batterCellCodeStartNumber" style="width: 85%;"></el-input>
                              </el-form-item>
                            </el-col>
                          </el-row>
                        </div>
                      </el-form>
                    </template>
                  </div>
                  <div class="temperatureConfig">
                    <template>
                      <el-form label-width="120px" label-position="left">
                        <el-form-item class="configTitle" label="温度配置">
                          <div class="configBtn">
                            <el-input-number v-model="temperatureNum[index]" @change="(oldval, newval) => temperatureHandleChange(oldval, newval, index)" :min="0" label="描述文字" style="width: 150px;"></el-input-number>
                            <el-button :type="item.temperatureIsFixZero?'primary':''" @click="temperatureIsFixZeroClick(index)">温度编号是否补0</el-button>
                          </div>
                        </el-form-item>
                      </el-form>
                    </template>
                    <template>
                      <el-form class="configArea" label-width="120px" label-position="right">
                        <div v-for="(item2, index2) in item.temperatureRules" :key="index2">
                          <el-row>
                            <el-col :span="12">
                              <el-form-item label="温度前缀:">
                                <el-input v-model="item2.temperatureCodePrefix" style="width: 85%;"></el-input>
                              </el-form-item>
                            </el-col>
                            <el-col :span="12">
                              <el-form-item label="温度个数:">
                                <el-input v-model="item2.temperatureCount" style="width: 85%;"></el-input>
                              </el-form-item>
                            </el-col>
                          </el-row>
                          <el-row>
                            <el-col :span="12">
                              <el-form-item>
                                <el-button :type="item2.temperatureIsChar?'primary':''" @click="temperatureIsCharClick(index, index2)">是否纯字符</el-button>
                              </el-form-item>
                            </el-col>
                            <el-col :span="12">
                              <el-form-item label="起始数:">
                                <el-input v-model="item2.temperatureCodeStartNumber" style="width: 85%;"></el-input>
                              </el-form-item>
                            </el-col>
                          </el-row>
                        </div>
                      </el-form>
                    </template>
                  </div>
                  <div class="socConfig">
                    <template>
                      <el-form label-width="120px" label-position="left">
                        <el-form-item class="configTitle" label="SOC配置">
                          <div class="configBtn">
                            <el-input-number v-model="socNum[index]" @change="(oldval, newval) => socHandleChange(oldval, newval, index)" :min="0" label="描述文字" style="width: 150px;"></el-input-number>
                            <el-button :type="item.socIsFixZero?'primary':''" @click="socIsFixZeroClick(index)">SOC编号是否补0</el-button>
                          </div>
                        </el-form-item>
                      </el-form>
                    </template>
                    <template>
                      <el-form class="configArea" label-width="120px" label-position="right">
                        <div v-for="(item2, index2) in item.socRules" :key="index2">
                          <el-row>
                            <el-col :span="12">
                              <el-form-item label="SOC前缀:">
                                <el-input v-model="item2.socCodePrefix" style="width: 85%;"></el-input>
                              </el-form-item>
                            </el-col>
                            <el-col :span="12">
                              <el-form-item label="SOC个数:">
                                <el-input v-model="item2.socCount" style="width: 85%;"></el-input>
                              </el-form-item>
                            </el-col>
                          </el-row>
                          <el-row>
                            <el-col :span="12">
                              <el-form-item>
                                <el-button :type="item2.socIsChar?'primary':''" @click="socIsCharClick(index, index2)">是否纯字符</el-button>
                              </el-form-item>
                            </el-col>
                            <el-col :span="12">
                              <el-form-item label="起始数:">
                                <el-input v-model="item2.socCodeStartNumber" style="width: 85%;"></el-input>
                              </el-form-item>
                            </el-col>
                          </el-row>
                        </div>
                      </el-form>
                    </template>
                  </div>
                  <div class="sohConfig">
                    <template>
                      <el-form label-width="120px" label-position="left">
                        <el-form-item class="configTitle" label="SOH配置">
                          <div class="configBtn">
                            <el-input-number v-model="sohNum[index]" @change="(oldval, newval) => sohHandleChange(oldval, newval, index)" :min="0" label="描述文字" style="width: 150px;"></el-input-number>
                            <el-button :type="item.sohIsFixZero?'primary':''" @click="sohIsFixZeroClick(index)">SOH编号是否补0</el-button>
                          </div>
                        </el-form-item>
                      </el-form>
                    </template>
                    <template>
                      <el-form class="configArea" label-width="120px" label-position="right">
                        <div v-for="(item2, index2) in item.sohRules" :key="index2">
                          <el-row>
                            <el-col :span="12">
                              <el-form-item label="SOH前缀:">
                                <el-input v-model="item2.sohCodePrefix" style="width: 85%;"></el-input>
                              </el-form-item>
                            </el-col>
                            <el-col :span="12">
                              <el-form-item label="SOH个数:">
                                <el-input v-model="item2.sohCount" style="width: 85%;"></el-input>
                              </el-form-item>
                            </el-col>
                          </el-row>
                          <el-row>
                            <el-col :span="12">
                              <el-form-item>
                                <el-button :type="item2.sohIsChar?'primary':''" @click="sohIsCharClick(index, index2)">是否纯字符</el-button>
                              </el-form-item>
                            </el-col>
                            <el-col :span="12">
                              <el-form-item label="起始数:">
                                <el-input v-model="item2.sohCodeStartNumber" style="width: 85%;"></el-input>
                              </el-form-item>
                            </el-col>
                          </el-row>
                        </div>
                      </el-form>
                    </template>
                  </div>
                </div>
              </div>
            </el-form>
          </div>
          <el-form class="operationBtn">
            <el-row>
              <el-col :span="8">
                <el-form-item>
                  <el-button type="primary" @click="addProjectFieldsConfig()">生成</el-button>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item>
                  <!-- <el-button @click="importHistoryEMS()">导入历史EMS</el-button> -->
                  <el-button type="warning" @click="deleteClick()">删除并保留</el-button>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item>
                  <el-button type="danger" @click="clearClick()">清空</el-button>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-card>
      </el-col>
      <el-col :span="20" v-show="!currentSn">
        <el-card shadow="never" style="text-align: center;min-height: 300px;line-height: 300px;">暂无数据</el-card>
      </el-col>
    </el-row>
  </el-card>
  <el-dialog title="导入历史EMS配置" :visible.sync="dialogVisible" width="50%">
    <p class="title">项目列表</p>
    <div class="project-list">
      <ul>
        <li v-for="(item, index) in projectList" :key="index" :class="{ actived: currentProjectId == item.projectId }">
          <div @click="clickProject(item)">{{ item.projectName }}</div>
        </li>
      </ul>
    </div>
    <div class="emsList">
      <el-radio-group v-model="radio" @change="changeEMS()">
        <el-radio v-for="(item, index) in project_ems_List" :key="index" :label="item.sn">{{item.sn}}（簇:{{item.cellClusterCount}}，电压:{{item.batteryCellCount}}，温度:{{item.temperatureCount}}）</el-radio>
      </el-radio-group>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="submitHistoryEMS()">确 定</el-button>
    </span>
  </el-dialog>
  <!-- 数据点 -->
  <Dialog ref="dataPointDialog" title="数据点配置" dlgWidth="50%" @closeDialog="closeDataPointDialog">
    <DataPointConfiguration :isDialog="isDataPointDialog" :projectId="projectId" @currRowData="getCurrRowData($event)"></DataPointConfiguration>
    <template slot="footer">
      <el-button type="primary" @click="dataPointSubmit()">确定</el-button>
    </template>
  </Dialog>
</div>
</template>

<script>
import PROJECTAPI from '@/api/project';
import D_PROJECTAPI from '@/views/design/api/project';
import Dialog from '@/components/dialog';
import DataPointConfiguration from '../../svolt/components/data-point-configuration.vue';
export default {
  props: {
    projectName: {
      type: [String, Number]
    },
    projectId: {
      type: [String, Number]
    }
  },
  components: {
    Dialog,
    DataPointConfiguration
  },
  data() {
    return {
      emsData: [],
      currentSn: '', //当前的sn节点
      batteryCellTemplate: {
        batteryCellIsFixZero: false,
        batteryCellRules: [{
          batterCellCodeStartNumber: 0,
          batteryCellCodePrefix: "",
          batteryCellCount: 0,
          batteryCellIsChar: false
        }],
        cellClustersCodeIsContinue: false,
        cellClustersIsFixZero: false,
        cellClustersRules: {
          batteryStack: "",
          cellClustersCodePrefix: "",
          cellClustersCount: 1,
          cellClustersIsChar: false,
          electricity: "",
          groupCurrent: "",
          groupTerminalVoltage: "",
          majorNegative: "",
          majorPositive: "",
          moduleBunch: 0,
          moduleNumber: 0,
          negativeResistance: "",
          plugBoxNumber: 0,
          positiveResistance: "",
          socAvg: "",
          socFirstMaxValue: "",
          socFirstMinValue: "",
          socMaxCode: "",
          socMinCode: "",
          socRange: "",
          socSecondMaxValue: "",
          socSecondMinValue: "",
          socThirdMaxValue: "",
          socThirdMinValue: "",
          sohAvg: "",
          sohFirstMaxValue: "",
          sohFirstMinValue: "",
          sohMaxCode: "",
          sohMinCode: "",
          sohRange: "",
          sohSecondMaxValue: "",
          sohSecondMinValue: "",
          sohThirdMaxValue: "",
          sohThirdMinValue: "",
          temperatureAvg: "",
          temperatureFirstMaxValue: "",
          temperatureFirstMinValue: "",
          temperatureMaxCode: "",
          temperatureMinCode: "",
          temperatureRange: "",
          temperatureSecondMaxValue: "",
          temperatureSecondMinValue: "",
          temperatureThirdMaxValue: "",
          temperatureThirdMinValue: "",
          todayCharge: "",
          todayDischarge: "",
          totalCharge: "",
          totalDischarge: "",
          voltage: "",
          voltageAvg: "",
          voltageFirstMaxValue: "",
          voltageFirstMinValue: "",
          voltageMaxCode: "",
          voltageMinCode: "",
          voltageRange: "",
          voltageSecondMaxValue: "",
          voltageSecondMinValue: "",
          voltageThirdMaxValue: "",
          voltageThirdMinValue: ""
        },
        temperatureIsFixZero: false,
        temperatureRules: [{
          temperatureCodePrefix: "",
          temperatureCodeStartNumber: 0,
          temperatureCount: 0,
          temperatureIsChar: false
        }],
        socIsFixZero: false,
        socRules: [{
          socCodePrefix: "",
          socCodeStartNumber: 0,
          socCount: 0,
          socIsChar: false
        }],
        sohIsFixZero: false,
        sohRules: [{
          sohCodePrefix: "",
          sohCodeStartNumber: 0,
          sohCount: 0,
          sohIsChar: false
        }],
      },
      fieldRuleConfig: [],
      templateNum: 0,
      batteryCellNum: [],
      temperatureNum: [],
      socNum: [],
      sohNum: [],
      dialogVisible: false,
      emsList: [],
      radio: "",
      emsHistoryData: [],
      projectList: [],
      currentProjectId: this.projectId,
      project_ems_List: [],
      options: [],
      start: 0,
      end: 10,
      pageTotal: 10,
      keyWord: '',
      isClearForm: false,
      isDataPointDialog: false
    };
  },
  created() {
    this.batterySearchEmsList();
  },
  methods: {
    openDialog(index, val) {
      this.$refs.dataPointDialog.open();
      this.isDataPointDialog = true;
      this.index = index;
      this.val = val;
    },
    closeDataPointDialog() {
      this.$refs.dataPointDialog.close();
      this.isDataPointDialog = false;
    },
    getCurrRowData(row) {
      this.currRow = row;
    },
    dataPointSubmit() {
      this.$refs.dataPointDialog.close();
      this.isDataPointDialog = false;
      this.fieldRuleConfig[this.index].cellClustersRules[this.val] = this.currRow.field;
    },
    //查询ems列表
    batterySearchEmsList() {
      let params = {
        projectId: this.projectId
      };
      PROJECTAPI.batterySearchEmsList(params).then(res => {
        if (res.data.code == 200) {
          this.emsData = res.data.data;
        }
      });
    },
    //点击ems
    clickEms(row) {
      this.currentSn = row.sn;
      this.searchFiledConfigByEMS(row.sn);
    },
    //查询ems下电芯配置详情
    searchFiledConfigByEMS(sn) {
      let params = {
        emsSn: sn
      };
      PROJECTAPI.searchFiledConfigByEMS(params).then(res => {
        this.fieldRuleConfig = [];
        if (res.data.code == 200) {
          if (res.data.data.fieldRuleConfig.length > 0) {
            this.fieldRuleConfig = res.data.data.fieldRuleConfig;
            this.emsHistoryData = res.data.data.fieldRuleConfig;
          } else {
            this.fieldRuleConfig.push(this.batteryCellTemplate);
          }
          this.templateNum = this.fieldRuleConfig.length;
          for (let i in this.fieldRuleConfig) {
            this.batteryCellNum[i] = this.fieldRuleConfig[i].batteryCellRules.length;
            this.temperatureNum[i] = this.fieldRuleConfig[i].temperatureRules.length;
            this.socNum[i] = this.fieldRuleConfig[i].socRules.length;
            this.sohNum[i] = this.fieldRuleConfig[i].sohRules.length;
          }
        }
      });
    },
    //电池簇编号是否连续
    cellClustersCodeIsContinueClick(index) {
      this.fieldRuleConfig[index].cellClustersCodeIsContinue = !this.fieldRuleConfig[index].cellClustersCodeIsContinue;
    },
    //电池簇编号是否补0
    cellClustersIsFixZeroClick(index) {
      this.fieldRuleConfig[index].cellClustersIsFixZero = !this.fieldRuleConfig[index].cellClustersIsFixZero;
    },
    //电池簇编号是否是字符
    cellClustersIsCharClick(index) {
      this.fieldRuleConfig[index].cellClustersRules.cellClustersIsChar = !this.fieldRuleConfig[index].cellClustersRules.cellClustersIsChar;
    },
    //加减电池簇模板
    templateHandleChange(newVal, oldVal) {
      if (newVal > oldVal) {
        this.fieldRuleConfig.push(JSON.parse(JSON.stringify(this.batteryCellTemplate))); //深拷贝
      } else {
        this.fieldRuleConfig.splice(this.fieldRuleConfig.length - 1, 1);
      }
      for (let i in this.fieldRuleConfig) {
        this.batteryCellNum[i] = this.fieldRuleConfig[i].batteryCellRules.length;
        this.temperatureNum[i] = this.fieldRuleConfig[i].temperatureRules.length;
        this.socNum[i] = this.fieldRuleConfig[i].socRules.length;
        this.sohNum[i] = this.fieldRuleConfig[i].sohRules.length;
      }
      this.$nextTick(() => {
        this.$refs["templateFormRef"].resetFields();
      })
    },
    //电压编号是否补0
    batteryCellIsFixZeroClick(index) {
      this.fieldRuleConfig[index].batteryCellIsFixZero = !this.fieldRuleConfig[index].batteryCellIsFixZero;
    },
    //电芯是否是字符
    batteryCellIsCharClick(index, index1) {
      this.fieldRuleConfig[index].batteryCellRules[index1].batteryCellIsChar = !this.fieldRuleConfig[index].batteryCellRules[index1].batteryCellIsChar;
    },
    batteryCellHandleChange(newVal, oldVal, index) {
      if (newVal > oldVal) {
        this.fieldRuleConfig[index].batteryCellRules.push({
          batterCellCodeStartNumber: "",
          batteryCellCodePrefix: "",
          batteryCellCount: "",
          batteryCellIsChar: false
        })
      } else {
        this.fieldRuleConfig[index].batteryCellRules.splice(this.fieldRuleConfig[index].batteryCellRules.length - 1, 1);
      }
    },
    //温度是否补0
    temperatureIsFixZeroClick(index) {
      this.fieldRuleConfig[index].temperatureIsFixZero = !this.fieldRuleConfig[index].temperatureIsFixZero;
    },
    temperatureHandleChange(newVal, oldVal, index) {
      if (newVal > oldVal) {
        this.fieldRuleConfig[index].temperatureRules.push({
          temperatureCodePrefix: "",
          temperatureCodeStartNumber: "",
          temperatureCount: "",
          temperatureIsChar: false
        })
      } else {
        this.fieldRuleConfig[index].temperatureRules.splice(this.fieldRuleConfig[index].temperatureRules.length - 1, 1);
      }
    },
    //温度是否是字符
    temperatureIsCharClick(index, index2) {
      this.fieldRuleConfig[index].temperatureRules[index2].temperatureIsChar = !this.fieldRuleConfig[index].temperatureRules[index2].temperatureIsChar;
    },
    //SOC是否补0
    socIsFixZeroClick(index) {
      this.fieldRuleConfig[index].socIsFixZero = !this.fieldRuleConfig[index].socIsFixZero;
    },
    socHandleChange(newVal, oldVal, index) {
      if (newVal > oldVal) {
        this.fieldRuleConfig[index].socRules.push({
          socCodePrefix: "",
          socCodeStartNumber: "",
          socCount: "",
          socIsChar: false
        })
      } else {
        this.fieldRuleConfig[index].socRules.splice(this.fieldRuleConfig[index].socRules.length - 1, 1);
      }
    },
    //SOC是否是字符
    socIsCharClick(index, index2) {
      this.fieldRuleConfig[index].socRules[index2].socIsChar = !this.fieldRuleConfig[index].socRules[index2].socIsChar;
    },
    //SOH是否补0
    sohIsFixZeroClick(index) {
      this.fieldRuleConfig[index].sohIsFixZero = !this.fieldRuleConfig[index].sohIsFixZero;
    },
    sohHandleChange(newVal, oldVal, index) {
      if (newVal > oldVal) {
        this.fieldRuleConfig[index].sohRules.push({
          sohCodePrefix: "",
          sohCodeStartNumber: "",
          sohCount: "",
          sohIsChar: false
        })
      } else {
        this.fieldRuleConfig[index].sohRules.splice(this.fieldRuleConfig[index].sohRules.length - 1, 1);
      }
    },
    //SOH是否是字符
    sohIsCharClick(index, index2) {
      this.fieldRuleConfig[index].sohRules[index2].sohIsChar = !this.fieldRuleConfig[index].sohRules[index2].sohIsChar;
    },
    //导入历史EMS
    importHistoryEMS() {
      this.dialogVisible = true;
      this.searchProjectList();
      this.searchEmsImportList(this.currentProjectId);
    },
    //查询项目列表
    searchProjectList() {
      PROJECTAPI.searchProjectList().then(res => {
        let projectList = [];
        if (res.data.code == 200) {
          res.data.data.forEach(ele => {
            if (ele.isShow == 1) {
              projectList.push({
                projectId: ele.projectId,
                projectName: ele.projectName
              })
            }
          });
        }
        this.projectList = projectList;
      });
    },
    clickProject(item) {
      this.currentProjectId = item.projectId;
      this.searchEmsImportList(item.projectId);
    },
    //查询ems导入列表
    searchEmsImportList(projectId) {
      let params = {
        projectId: projectId
      }
      PROJECTAPI.searchEmsImportList(params).then(res => {
        if (res.data.code == 200) {
          this.project_ems_List = res.data.data;
        }
      });
    },
    changeEMS() {
      this.searchFiledConfigByEMS(this.radio);
    },
    //导入历史EMS配置
    submitHistoryEMS() {
      let params = {
        batteryCellConfig: this.emsHistoryData,
        emsSn: this.currentSn
      }
      PROJECTAPI.addProjectFieldsConfig(params).then(res => {
        if (res.data.code == 200) {
          this.$message.success('操作成功!');
          this.dialogVisible = false;
        }
      });
    },
    //生成
    addProjectFieldsConfig() {
      let params = {
        fieldRuleConfig: this.fieldRuleConfig,
        emsSn: this.currentSn
      }
      PROJECTAPI.addProjectFieldsConfig(params).then(res => {
        if (res.data.code == 200) {
          this.$message.success('操作成功!');
        }
      });
    },
    //删除并清空
    clearClick() {
      this.isClearForm = true;
      this.confirmDelete();
    },
    //删除
    deleteClick() {
      this.isClearForm = false;
      this.confirmDelete();
    },
    confirmDelete() {
      this.$confirm('此操作将删除该EMS配置信息, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.deleteProjectFieldsConfig();
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    deleteProjectFieldsConfig() {
      let params = {
        emsSn: this.currentSn
      };
      PROJECTAPI.deleteProjectFieldsConfig(params).then(res => {
        if (res.data.code == 200) {
          this.$message.success('删除成功!');
          if (this.isClearForm) {
            this.searchFiledConfigByEMS(this.currentSn);
          }
        }
      });
    },
    remoteMethod(query) {
      this.keyWord = query;
      this.start = 0;
      this.end = 10;
      if (query != '') {
        try {
          let params = {
            start: this.start,
            productTypeId: '',
            searchKey: query,
            end: this.end,
            topProductTypeId: '',
            type: 0,
            projectId: this.projectId
          };
          D_PROJECTAPI.getProjectFieldsByEs(params).then(res => {
            if (res.data.code == 200) {
              var result = res.data.data.dataList;
              if (result.length > 0) {
                for (let i in result) {
                  result[i].label = result[i].fields + '|' + result[i].fieldContent;
                  var el = document.createElement('div');
                  el.innerHTML = result[i].label;
                  el.getElementsByTagName('a'); // Live NodeList of your anchor elements
                  var el1 = document.createElement('div');
                  el1.innerHTML = result[i].fields;
                  el1.getElementsByTagName('a'); // Live NodeList of your anchor elements
                  result[i].value = el1.innerText;
                  result[i].id = result[i].emsSn + '@' + result[i].fieldsId;
                }
                this.options = result;
              }
              this.pageTotal = res.data.data.totalCount != 0 ? res.data.data.totalCount : 10;
            }
          });
        } catch (e) {
          console.log(e);
        }
      }
    },
    searchMore() {
      this.start += 10;
      this.end += 10;
      let self = this;
      try {
        let params = {
          start: this.start,
          productTypeId: null,
          searchKey: this.keyWord,
          end: this.end,
          topProductTypeId: null,
          type: 0,
          projectId: this.projectId
        };
        D_PROJECTAPI.getProjectFieldsByEs(params).then(res => {
          if (res.data.code == 200) {
            var result = res.data.data.dataList;
            if (result.length > 0) {
              for (let i in result) {
                result[i].label = result[i].fields + '|' + result[i].fieldContent;
                var el = document.createElement('div');
                el.innerHTML = result[i].label;
                el.getElementsByTagName('a'); // Live NodeList of your anchor elements
                var el1 = document.createElement('div');
                el1.innerHTML = result[i].fields;
                el1.getElementsByTagName('a'); // Live NodeList of your anchor elements
                result[i].value = el1.innerText;
                result[i].id = result[i].emsSn + '@' + result[i].fieldsId;
              }
              this.$nextTick(function () {
                self.options = self.options.concat(result);
                self.options = self.deleteObject(self.options);
              });
            } else {
              this.$message.warning('已无更多数据！');
            }
          }
        });
      } catch (e) {
        console.log(e);
      }
    },
    //删除数组对象中的重复对象
    deleteObject(obj) {
      var uniques = [];
      var stringify = {};
      for (var i = 0; i < obj.length; i++) {
        var keys = Object.keys(obj[i]);
        keys.sort(function (a, b) {
          return (Number(a) - Number(b));
        });
        var str = '';
        for (var j = 0; j < keys.length; j++) {
          str += JSON.stringify(keys[j]);
          str += JSON.stringify(obj[i][keys[j]]);
        }
        if (!stringify.hasOwnProperty(str)) {
          uniques.push(obj[i]);
          stringify[str] = true;
        }
      }
      uniques = uniques;
      return uniques;
    },
  }
};
</script>

<style lang="scss">
.projectcellconfig {
  .el-card__header {
    font-weight: bold;
    background: #f0f2f5;
    text-align: center;
  }

  .ems-list {
    margin: 0px;
    padding: 0px;
    max-height: 47vh;
    overflow: auto;

    li {
      list-style: none;
      line-height: 36px;
      padding: 0px;
      margin: 0px;

      &:hover {
        cursor: pointer;
        background-color: #f0f2f5;
      }
    }
  }

  .actived {
    background-color: #f0f2f5;
  }

  .batteryClusterTemplate {
    position: relative;
  }

  .batteryClusterConfig,
  .temperatureConfig,
  .socConfig,
  .sohConfig {
    margin-top: 40px;
  }

  .configTitle {
    .el-form-item__label {
      font-size: 16px;
      font-weight: 600;
    }
  }

  .configBtn {
    position: absolute;
    right: 10px;
  }

  .configArea {
    border: 1px solid #ebeef5;
    margin-left: 20px;
    padding: 20px;
  }

  .operationBtn {
    margin-top: 40px;
    text-align: center;
  }

  .el-dialog__body {
    height: 60vh;
    overflow-y: auto;
    padding: 10px 30px;
  }

  .el-radio-group {
    line-height: 30px;
  }

  .title {
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 10px;
  }

  .project-list {
    border: 1px solid #ccc;
    border-radius: 6px;
    width: 45%;
    height: 350px;
    float: left;
    margin: 0px;
    padding: 10px 20px;
    overflow: auto;

    li {
      list-style: none;
      line-height: 30px;
      padding: 0px;
      margin: 0px;

      &:hover {
        cursor: pointer;
        background-color: #f0f2f5;
      }
    }
  }

  .emsList {
    border: 1px solid #ccc;
    border-radius: 6px;
    width: 50%;
    height: 350px;
    float: left;
    margin-left: 20px;
    padding: 10px 20px;
    overflow: auto;
  }
}

button.el-button.moreBtn.el-button--text.el-button--small {
  color: #000;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  margin-left: 20px !important;
  margin-top: 10px !important;
}

button.el-button.moreBtn.el-button--text.el-button--small.is-disabled {
  color: #C0C4CC;
}
</style>



// WEBPACK FOOTER //
// src/views/boss/project/projectcellconfig.vue